import { CreateSupplierSchema } from "@/v2/schema/supplier";
import { Supplier } from "@/v2/types";
import axios from "axios";

const BASE_URL = import.meta.env.VITE_API_BASE_URL;

export default async function OnboardSupplier({
    token,
    data,
}: {
    token: string;
    data: CreateSupplierSchema;
}): Promise<Supplier> {
    try {
        const res = await axios.post(
            `${BASE_URL}/vendors/submit/${token}`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            },
        );
        return res.data;
    } catch (error) {
        console.error("Error onboarding supplier:", error);
        throw error;
    }
}
